window.MOGA_LICENSE_READY=(async()=>{
const key='moga_invoice_pro_session_v1';
const cloudKey='moga_cloud_session_v1';
const loginUrl='/pages/sf';
const apiEndpoint='https://moga-invoice-api.94kanav.workers.dev/verify';
const cloudApi='https://cloud.moga.lt';

const setReady=(session,store=localStorage)=>{
  try{store.setItem(key,JSON.stringify({...session,savedAt:Date.now()}));}catch(e){}
  window.MOGA_LICENSE_SESSION=session;
  window.dispatchEvent(new CustomEvent('moga:license-ready',{detail:session}));
  return session;
};

const trialTime=s=>Math.max(0,Number(s)||0);
const trialLicense=(tenant,trial)=>({
  id:'TRIAL-'+String(tenant?.id||'').slice(-8).toUpperCase(),
  license_id:'TRIAL-'+String(tenant?.id||'').slice(-8).toUpperCase(),
  company:tenant?.company||tenant?.name||'Bandomoji paskyra',
  email:tenant?.email||'',
  status:trial?.active?'trial_active':(trial?.status==='expired'?'trial_expired':'active'),
  plan:String(trial?.effectivePlan||trial?.basePlan||(trial?.active?'PREMIUM':'NONE')).toUpperCase(),
  version:'2.0',
  trial:true,
  trialActive:!!trial?.active,
  trialStatus:String(trial?.status||''),
  trialRemainingSeconds:trialTime(trial?.remainingSeconds),
  trialExpiresAt:trial?.expiresAt||null
});

/*
  Trial turi savo Cloud sesiją ir neturi mokamos licencijos kodo.
  Todėl ją priimame PIRMIAUSIA ir niekada nesiunčiame TRIAL-* į License API.
*/
try{
  const raw=localStorage.getItem(cloudKey);
  const cs=raw?JSON.parse(raw):null;
  if(cs?.token){
    const headers={Accept:'application/json',Authorization:'Bearer '+cs.token};
    const meRes=await fetch(cloudApi+'/v1/auth/me',{headers,cache:'no-store'});
    if(meRes.ok){
      const me=await meRes.json().catch(()=>({}));
      const tenant=me.tenant||cs.tenant||{};
      const isTrial=String(tenant?.externalLicenseId||'').toLowerCase().startsWith('trial_') || String(tenant?.id||'').toLowerCase().startsWith('trial_');
      if(isTrial){
        const trRes=await fetch(cloudApi+'/v1/trial/status',{headers,cache:'no-store'});
        if(!trRes.ok)throw new Error('Nepavyko gauti bandymo būsenos.');
        const td=await trRes.json().catch(()=>({}));
        const license=trialLicense(tenant,td.trial||{});
        const session={token:'TRIAL',code:'TRIAL-'+String(tenant?.id||'').slice(-12),license};
        return setReady(session,localStorage);
      }
    }else if(meRes.status===401){
      try{localStorage.removeItem(cloudKey);}catch(e){}
    }
  }
}catch(error){
  console.warn('MOGA SF trial sesijos patikrinimas nepavyko:',error);
}

let session=null;
let sessionStore=null;
for(const storage of [localStorage,sessionStorage]){
  try{
    const raw=storage.getItem(key);
    if(!raw)continue;
    const data=JSON.parse(raw);
    if(data&&data.license&&data.code){session=data;sessionStore=storage;break;}
  }catch(e){}
}
if(!session||!session.code){
  try{localStorage.removeItem(key);sessionStorage.removeItem(key);}catch(e){}
  location.replace(loginUrl);return;
}

/* Senas / likęs TRIAL įrašas be gyvos Cloud sesijos nėra galiojantis loginas. */
if(session?.license?.trial===true || String(session.code||'').toUpperCase().startsWith('TRIAL-')){
  try{localStorage.removeItem(key);sessionStorage.removeItem(key);}catch(e){}
  location.replace(loginUrl);return;
}

try{
  const response=await fetch(apiEndpoint,{
    method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'include',cache:'no-store',
    body:JSON.stringify({code:String(session.code||'').trim().replace(/\s+/g,'').toUpperCase(),source:'moga-invoice-pro-app',shop:window.Shopify?.shop||location.hostname})
  });
  let data={};try{data=await response.json();}catch(e){}
  if(!response.ok||data.ok===false||data.valid===false)throw new Error(data.message||'Licencija nebegalioja.');
  const license=data.license||data.data||data;
  if(String(license.status||'').toLowerCase()!=='active')throw new Error('Licencija nėra aktyvi.');
  return setReady({...session,token:data.token||session.token||'',license},sessionStore||localStorage);
}catch(error){
  console.warn('MOGA SF licencijos patikrinimas nepavyko:',error);
  try{localStorage.removeItem(key);sessionStorage.removeItem(key);}catch(e){}
  location.replace(loginUrl);return;
}
})();
